import React from 'react';
import { Star, Phone } from 'lucide-react';
import './Reviews.css';

const Reviews = () => {
  const reviews = [
    {
      text: "Highly recommended for verti-mowing. Removed nearly 10 years of unwanted thatch. My lawn was spongy — it's going to be the best lawn in the street again soon.",
      rating: 5
    },
    {
      text: "Highly recommended. Peter & Peter did an excellent job. Takes the lawn right back to the root and regrows new leaf. The sponge has been removed and is now firm.",
      rating: 5
    },
    {
      text: "Fantastic job. I called and he was at my house that day. Made the garden look great again.",
      rating: 5
    },
    {
      text: "Very professional. Massive garden clean up that went the extra mile.",
      rating: 5
    },
    {
      text: "I have used Peter for over 20 years. Professional, courteous, and reliable. Great knowledge of what he does and reasonably priced.",
      rating: 5
    },
    {
      text: "No fuss, reliable, and speedy. Photos texted through of completed job — much appreciated.",
      rating: 5
    },
    {
      text: "Very efficient and prompt. Always rings when due to come out. Pricing is very reasonable.",
      rating: 5
    },
    {
      text: "Fast service and knowledgeable. My lawn needed serious work that most wouldn't touch. Highly recommend.",
      rating: 5
    },
    {
      text: "Reliable, reasonably priced, and great advice on keeping the lawn maintained.",
      rating: 5
    },
    {
      text: "Quick and efficient service.",
      rating: 5
    },
    {
      text: "Well priced, fast service, and knowledgeable.",
      rating: 5
    },
    {
      text: "Professional lawn care with excellent results. Very happy with the verti-mowing work done.",
      rating: 5
    },
    {
      text: "Great communication and reliable service. Lawn looks better than it has in years.",
      rating: 5
    },
    {
      text: "Prompt, professional, and the results speak for themselves. Would definitely use again.",
      rating: 5
    }
  ];

  return (
    <div className="reviews-page">
      {/* Hero Section */}
      <section className="reviews-hero">
        <div className="container">
          <h1 className="display-medium">Customer Reviews</h1>
          <div className="overall-rating">
            <div className="rating-stars">
              <Star size={32} fill="#D3FF62" color="#D3FF62" />
              <Star size={32} fill="#D3FF62" color="#D3FF62" />
              <Star size={32} fill="#D3FF62" color="#D3FF62" />
              <Star size={32} fill="#D3FF62" color="#D3FF62" />
              <Star size={32} fill="#D3FF62" color="#D3FF62" />
            </div>
            <p className="display-small" style={{ marginTop: '16px' }}>5.0</p>
            <p className="body-large" style={{ marginTop: '8px' }}>Based on 14 Google Reviews</p>
          </div>
        </div>
      </section>

      {/* Reviews Grid */}
      <section className="reviews-section">
        <div className="container">
          <div className="reviews-grid">
            {reviews.map((review, index) => (
              <div key={index} className="review-card">
                <div className="stars">
                  {[...Array(review.rating)].map((_, i) => (
                    <Star key={i} size={18} fill="#D3FF62" color="#D3FF62" />
                  ))}
                </div>
                <p className="body-medium" style={{ marginTop: 'var(--spacing-small)' }}>
                  "{review.text}"
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Trust Badges */}
      <section className="trust-section">
        <div className="container">
          <div className="trust-card">
            <h2 className="heading-2" style={{ textAlign: 'center' }}>Why Customers Trust Us</h2>
            <div className="trust-grid">
              <div className="trust-item">
                <h3 className="heading-3">20+ Years</h3>
                <p className="body-medium">Experience in lawn care</p>
              </div>
              <div className="trust-item">
                <h3 className="heading-3">5.0 Rating</h3>
                <p className="body-medium">Perfect Google score</p>
              </div>
              <div className="trust-item">
                <h3 className="heading-3">Same Day</h3>
                <p className="body-medium">Service often available</p>
              </div>
              <div className="trust-item">
                <h3 className="heading-3">Local</h3>
                <p className="body-medium">Ballajura-based</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="reviews-cta">
        <div className="container">
          <div className="cta-banner">
            <h2 className="heading-1" style={{ color: 'white' }}>Join Our Happy Customers</h2>
            <p className="body-large" style={{ color: 'rgba(255, 255, 255, 0.9)', marginTop: '16px' }}>
              Experience the same professional service that earned us 14 five-star reviews.
            </p>
            <div className="cta-buttons">
              <a href="tel:0417910217" className="btn-cta" style={{ background: 'white', color: 'var(--brand-dark)' }}>
                <Phone size={20} />
                Call 0417 910 217
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Mobile Sticky CTA */}
      <div className="mobile-cta-sticky">
        <a href="tel:0417910217" className="btn-primary" style={{ width: '100%', justifyContent: 'center' }}>
          <Phone size={18} />
          Call Now: 0417 910 217
        </a>
      </div>
    </div>
  );
};

export default Reviews;